import React, { Component, useState } from "react";
import styled from "styled-components";

//components
import { StyledText, Button } from "../../components/common/basic";
import { BackButton, MarkIcon } from "../../components/svgs";

// theme
import { useTheme } from "../../hooks/";

const ThemeSelectorScreen = () => {
  const { themeContext, theme } = useTheme();
  const { activeTheme, setActiveTheme } = themeContext;
  const [selectedTheme, setSelectedTheme] = useState([
    false,
    true,
    false,
    false,
    false,
    false,
  ]);
  const [themeIndex, SetThemeIndex] = useState(0);

  const themes = [
    "fuscia",
    "amber",
    "jasmine",
    "turquoise",
    "mauve",
    "midnight",
  ];

  let themeColor = "background";

  const handleChange = (index) => {
    const newTheme = selectedTheme.map((item, i) => {
      if (index == i) {
        return true;
      } else {
        return false;
      }
    });

    setSelectedTheme(newTheme);
  };

  return (
    <MainHolder>
      <AppHeader
        activeTheme={theme.colors[themeContext.activeTheme][themeColor]}
      >
        <BackButtonHolder>
          <BackButton />
        </BackButtonHolder>
        <StyledText color={"white"}>Colour Theme</StyledText>
      </AppHeader>
      <ContentContainer>
        <StyledText
          style={{ textAlign: "center" }}
          fontFamily="bold"
          margin={20}
        >
          Choose your theme
        </StyledText>
        <ThemeContainer>
          {themes.map((item, index) => {
            return (
              <ColourThemes
                key={index}
                backgroundColor={theme.colors[item][themeColor]}
                onClick={() => {
                  handleChange(index);
                  SetThemeIndex(index);
                }}
              >
                {selectedTheme[index] && <MarkIcon />}
              </ColourThemes>
            );
          })}
        </ThemeContainer>
        <ButtonHolder>
          <Button
            margin={20}
            onClick={() => {
              setActiveTheme(themes[themeIndex]);
            }}
            color={theme.colors[themeContext.activeTheme][themeColor]}
          >
            <StyledText color={"white"}>{"select theme"}</StyledText>
          </Button>
        </ButtonHolder>
      </ContentContainer>
    </MainHolder>
  );
};

const MainHolder = styled.div`
  display: grid;
  align-content: space-between;
  grid-template-rows: auto auto 1fr;
  overflow: hidden;
  height: 700px;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const AppHeader = styled.div`
  display: flex;
  height: 50px;
  background-color: ${({ activeTheme }) => activeTheme};
  align-items: center;
  padding: 10px;
`;

const BackButtonHolder = styled.div`
  margin-right: 50px;
`;

const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

const ThemeContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto 1fr;
  align-items: center;
  grid-column-gap: 30px;
  grid-row-gap: 20px;
  justify-items: center;
  margin: 50px;
`;

const ColourThemes = styled.div`
  display: grid;
  width: 60px;
  height: 60px;
  border-radius: 30px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  justify-content: center;
  align-content: center;
`;

const ButtonHolder = styled.div`
  display: grid;
  align-content: center;
  margin-top: 150px;
`;

export default ThemeSelectorScreen;
